import Workpage from "../landing/work page/work_page";

const Inspiration = () => {
  return (
    <>
      <div style={{marginTop: '10vh'}}>
        <Workpage />
      </div>
    </>
  );
};

export default Inspiration;
